import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/element-variables.scss'; //自定义主题
import './components/common/directives';
import api from "./http/api";
import http from "./http/http";
import "./http/axios";
import _ from 'lodash'
import VueDraggableResizable from 'vue-draggable-resizable'
import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
import Vant from 'vant';
// import 'vant/lib/index.css';
import 'vant/lib/index.less';
import * as echarts from 'echarts';

Vue.component('vue-draggable-resizable', VueDraggableResizable)
Vue.prototype.$_ = _
Vue.prototype.$api = api;
Vue.prototype.$http = http;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI, {
    size: 'small'
});
Vue.use(Vant);

// 若是没有开启Devtools工具，在开发环境中开启，在生产环境中关闭
if (process.env.NODE_ENV == 'development') {
    Vue.config.devtools = true;
} else {
    Vue.config.devtools = false;
}

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    let role = '';
    if(localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined'){
        role = JSON.parse(localStorage.getItem('user'));
    }
    if (!role && to.path !== '/login') {
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        // role.username === 'admin' ? next() : next('/403');
        next();
    } else {
        next();
    }
});

Vue.filter('moneyFormat', function(money) {
    // 判断是否为数字或字符串形式的数字
    if (typeof money === 'number' || (typeof money === 'string' && !isNaN(Number(money)))) {
        money = String(money);
        var left = money.split('.')[0],
            right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00';
        var temp = left
            .split('')
            .reverse()
            .join('')
            .match(/(\d{1,3})/g);
        return (
            (Number(money) < 0 ? '-' : '') +
            temp
                .join(',')
                .split('')
                .reverse()
                .join('') +
            right
        );
    } else if (money === 0) {
        return '0.00';
    } else {
        return money;
    }
});

Vue.filter('numFormat', function(money) {
    if (money && money != null) {
        money = String(money);
        var left = money.split('.')[0],
            right = money.split('.')[1];
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '';
        var temp = left
            .split('')
            .reverse()
            .join('')
            .match(/(\d{1,3})/g);
        return (
            (Number(money) < 0 ? '-' : '') +
            temp
                .join(',')
                .split('')
                .reverse()
                .join('') +
            right
        );
    } else {
        return '0';
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
